import en from "./en";
import ko from "./ko";
import jp from "./jp";

export default {
  en,
  ko,
  jp,
};
